import React from "react";
import styles from "./VehicleInformation.module.css"
import {Section} from "../../../../../elements/section/Section";
import {FullLocationUi} from "../../../../../../api/generated";
import {TextField} from "../../../../../elements/textField/TextField";
import {
    getVehicleDataProviderName
} from "../../../../assistant/modal/createAndUpdate/components/util/vehicleDataProviderUtil";

interface LocationDetailsProps {
    location: FullLocationUi
}

export const VehicleInformation: React.FC<LocationDetailsProps> = ({
                                                                       location
                                                                   }) => {
    return <Section title={"Vehicle Information"}>
        <div className={styles.fieldsWrapper}>
            <div className={styles.wrapper}>
                <TextField title={"Data Provider"} value={getVehicleDataProviderName(location.vehicleDataProvider)}/>
                {location.advertiserId && <TextField title={"Dealer ID"} value={location.advertiserId}/>}
                {location.filePath && <TextField title={"File Path"} value={location.filePath}/>}
                {location.feedId && <TextField title={"Feed ID"} value={location.feedId}/>}
            </div>
        </div>
    </Section>
}
